<template>
  <div class="select-user">
    <div class="logo">
      <div>MYTutor</div>
    </div>
    <div>
      <div v-for="item in childList" :key="item.id" class="child-item" @click="selectChild(item)">
        <div class="name-div"><span class="name">{{item.username}}</span><span>{{$t('selectUser.name')}}</span></div>
        <div class="info">
          <span><img :src="require('@/assets/age.png')" alt="age"><span style="font-weight: 600;display: unset">{{$t('selectUser.Age')}}：</span>{{ item.age }}</span>
          <span><img :src="require('@/assets/sex.png')" alt="sex"><span style="font-weight: 600;display: unset">{{$t('selectUser.Sex')}}：</span>{{ item.sex === 1 ? $t('register.male') : $t('register.female') }}</span>
          <span><img :src="require('@/assets/tel.png')" alt="tel"><span style="font-weight: 600;display: unset">{{$t('selectUser.Tel')}}：</span>{{ item.tel }}</span>
        </div>

      </div>
    </div>

    <div @click="startDialogue" class="start-dialogue">{{ $t('selectUser.Start') }}<i class="el-icon-right" /> </div>
  </div>
</template>
<script>
import { findChild } from '@/api/user'

export default {
  name: 'SelectUser',
  data () {
    return {
      userInfo: null,
      childList: []
    }
  },
  created () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      findChild({ id: this.userInfo.id }).then(res => {
        if (res.code !== 200) {
          return false
        }
        if (res.data.length === 0) {
          this.startDialogue()
          return false
        }
        this.childList = res.data
      })
    },
    startDialogue () {
      const { topic, redirect } = this.$route.query
      if (redirect === '/chat' && topic) {
        this.$router.push({
          path: redirect,
          query: { topic }
        })
      } else {
        this.$router.push('/')
      }
    },
    selectChild (item) {
      this.$router.push({
        path: '/chat',
        query: {
          childName: item.username
        }
      })
    }
  }
}
</script>

<style scoped>
.select-user {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("~@/assets/banner-background.webp") no-repeat center center;
  .logo div {
    height: 60px;
    color: #409EFF;
    font-size: 60px;
    display: flex;
    font-weight: 700;
    align-items: center;
    font-family: 'Orbitron', 'Rajdhani', sans-serif;
    letter-spacing: 2px;
    font-style: italic;
    text-transform: uppercase;
    margin: 100px 0 120px;
  }
  .child-item{
    padding: 24px 32px 28px;
    width: 368px;
    height: 157px;
    background-color: #f9fbff;
    box-shadow:
      0 0 0 1px #e2e8f0,
      0 4px 8px rgba(0, 0, 0, .1),
      0 16px 32px rgba(0, 0, 0, .15),
      0 0 12px rgba(0, 0, 0, .1);
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    .name-div{
      padding-bottom: 12px;
      border-bottom: 1px solid #B4B4B4;
      text-align: center;
    }
    .name{
      color: rgb(77 107 254/1);
      font-weight: 700;
      font-size: 20px;
      margin-right: 6px;
    }
    .info{
      span{
        width: 50%;
        display: inline-block;
        margin-top: 12px;
        img{
          margin-right: 6px;
        }
      }
    }
    span{
      color: rgb(100 116 139/1);
      font-size: 15px;
      line-height: 22px;
    }
  }
  .start-dialogue{
    cursor: pointer;
    margin-top: 50px;
    font-size: 18px;
    color: rgb(100 116 139/1);
    font-weight: 600;
  }
}
</style>
